export function bigIntMax(...args) {
    return args.reduce((m, e) => (e > m ? e : m));
}
export function bigIntMin(...args) {
    return args.reduce((m, e) => (e < m ? e : m));
}
export function toBigInt32(value) {
    return BigInt(value) % BigInt(4294967296);
}
export function toBigInt64(value) {
    return BigInt(value) % BigInt("18446744073709551616");
}
export function numberToBigInt(value) {
    return BigInt(Math.trunc(value));
}
const integerRegex = /^-?[0-9]+$/;
export function parseBigInt(value) {
    if (value == null)
        return undefined;
    if (value.length === 0)
        return BigInt(0);
    return integerRegex.test(value) ? BigInt(value) : undefined;
}
